// Additional settings tab — branding, the mobile welcome screen and the support
// contact. Reads the same GET as the General tab (RTK Query dedupes the cache
// key, and only the active tab is mounted), so each tab stays self-contained
// with its own loading and error states rather than threading props down.

import { useTranslation } from 'react-i18next';
import ContactAdministratorCard from './ContactAdministratorCard';
import CustomBrandingCard from './CustomBrandingCard';
import WelcomeScreenCard from './WelcomeScreenCard';
import { Button, Icon } from '@/components/common';
import { useGetCompanySettingsQuery } from '@/api/endpoints/companySettingsApi';

const AdditionalSettingsTab = () => {
  const { t } = useTranslation();
  const { data: settings, isFetching, isError, refetch } = useGetCompanySettingsQuery();

  if (isFetching && !settings) {
    return (
      <div className='company-settings__status'>
        <span className='company-settings__spinner' aria-hidden='true' />
        <p className='company-settings__status-text'>{t('text_loading')}</p>
      </div>
    );
  }

  if (isError || !settings) {
    return (
      <div className='company-settings__status'>
        <Icon name='circle-alert' size={28} />
        <p className='company-settings__status-text'>{t('company_settings_load_error')}</p>
        <Button variant='secondary' iconStart='rotate-cw' onClick={() => void refetch()}>
          {t('forms_builder_retry')}
        </Button>
      </div>
    );
  }

  return (
    <div className='company-settings__column'>
      <CustomBrandingCard brand={settings.brand} />
      <WelcomeScreenCard welcome={settings.welcome} />
      <ContactAdministratorCard support={settings.support} />
    </div>
  );
};

export default AdditionalSettingsTab;
